import {AdditionalProps} from 'modules/additionals/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import additionalGroupsKeys from '../util/additional-groups-keys';

const useReorderAdditionalGroupAdditionalsIndexes = (
  additionalGroupId: string,
) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: AdditionalProps[]) =>
    setData(additionalGroupsKeys.additionals(additionalGroupId), data);

  return useApiMutation({
    url: `/additional-groups/${additionalGroupId}/reorder-indexes`,
    method: 'PATCH',
    errorTitle: 'Erro ao ordenar adicionais',
    onSuccess,
  });
};

export default useReorderAdditionalGroupAdditionalsIndexes;
